<template>
    <nav id="navbar-main" class="navbar is-fixed-top dark:bg-gray-900 dark:border-gray-800 border-gray-100">
        <div class="navbar-brand">
            <a class="navbar-item mobile-aside-button">
                <!--                <span class="icon"><i class="mdi mdi-forwardburger mdi-24px"></i></span>-->
                <span class="icon">
                <svg viewBox="0 0 24 24" width="24" height="24" class="inline-block"><path fill="currentColor"
                                                                                           d="M19,13H3V11H19L15,7L16.4,5.6L22.8,12L16.4,18.4L15,17L19,13M3,6H13V8H3V6M13,16V18H3V16H13Z"></path></svg>
                </span>
            </a>
        </div>
        <div class="navbar-brand is-right">
            <a class="navbar-item --jb-navbar-menu-toggle" data-target="navbar-menu">
                <!--                <span class="icon"><i class="mdi mdi-dots-vertical mdi-24px"></i></span>-->
                <span class="icon">
                <svg viewBox="0 0 24 24" width="24" height="24" class="inline-block"><path fill="currentColor"
                                                                                           d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z"></path></svg>
                </span>
            </a>
        </div>
        <div class="navbar-menu dark:bg-gray-900 dark:border-gray-800 border-gray-100" id="navbar-menu">
            <div class="navbar-end">
                <div class="navbar-item dropdown has-divider has-user-avatar">
                    <a class="navbar-link dark:!bg-gray-900 dark:border-gray-800 border-gray-100">
                        <div v-if="$page.props.jetstream.managesProfilePhotos" class="user-avatar">
                            <img :src="$page.props.user.profile_photo_url" :alt="$page.props.user.name"
                                 class="rounded-full">
                        </div>
                        <div class="is-user-name"><span>{{ $page.props.user.name }}</span></div>
                        <span class="icon"><i class="mdi mdi-chevron-down"></i></span>
                    </a>
                    <div class="navbar-dropdown dark:!bg-gray-900 dark:border-gray-800 border-gray-100">
                        <!--                        <a :href="route('profile.show')" class="navbar-item">-->
                        <!--                            <span class="icon"><i class="mdi mdi-account"></i></span>-->
                        <!--                            <span>My Profile</span>-->
                        <!--                        </a>-->
                        <!--                        <hr class="navbar-divider">-->
                        <form @submit.prevent="logout">
                            <button type="submit" class="navbar-item">
                                <span class="icon"><i class="mdi mdi-logout"></i></span>
                                <span>Log Out</span>
                            </button>
                        </form>

                    </div>
                </div>
            </div>
        </div>
    </nav>

</template>

<script>
import JetApplicationMark from "@/Jetstream/ApplicationMark";
import JetBanner from "@/Jetstream/Banner";
import JetDropdown from "@/Jetstream/Dropdown";
import JetDropdownLink from "@/Jetstream/DropdownLink";
import JetNavLink from "@/Jetstream/NavLink";
import JetResponsiveNavLink from "@/Jetstream/ResponsiveNavLink";
import Button from "@/Jetstream/Button";

export default {
    name: "Navbar",
    components: {
        Button,
        JetApplicationMark,
        JetBanner,
        JetDropdown,
        JetDropdownLink,
        JetNavLink,
        JetResponsiveNavLink,
    },
    data() {
        return {
            showingNavigationDropdown: false,
        }
    },

    methods: {
        switchToTeam(team) {
            this.$inertia.put(route('current-team.update'), {
                'team_id': team.id
            }, {
                preserveState: false
            })
        },

        logout() {
            this.$inertia.post(route('logout'));
        },
    }
}
</script>

<style scoped>

</style>
